import ItemWeb from "../viewItems/ItemWeb";
import React from "react";
import ItemMobile from "../viewItems/ItemMobile";

const FacilitiesList = (props) =>{
    const { dispatch, isSubmenuOpen, facilities, getLocationById, _exchangeLabel, onShowTrackings, onShowGenerateNewPin, onRemoveFacility, onGetQRCodeHandler, onOpenDoor, onOpenSlot, onRemoveSlot, showStatus, openSubmenuHandle, onShowSlotHistories} = props;
    return (
        <>
            <div id="inb-c-main-facilities" className="inb-c-listing off-canvas-content" data-off-canvas-content="">
            {facilities.map((facility, index)  => {
                return(
                    <>
                        <ItemWeb
                            dispatch={dispatch}
                            facility={facility}
                            isSubmenuOpen={isSubmenuOpen}
                            getLocationById={getLocationById}
                            _exchangeLabel={_exchangeLabel}
                            onShowTrackings={onShowTrackings}
                            onShowGenerateNewPin={onShowGenerateNewPin}
                            onRemoveFacility={onRemoveFacility}
                            onGetQRCodeHandler={onGetQRCodeHandler}
                            onOpenDoor={onOpenDoor}
                            onRemoveSlot={onRemoveSlot}
                            showStatus={showStatus}
                            onShowSlotHistories={onShowSlotHistories}
                            openSubmenuHandle={openSubmenuHandle}
                            onOpenSlot={onOpenSlot}
                            index={index}
                        />
                        <ItemMobile
                            dispatch={dispatch}
                            facility={facility}
                            isSubmenuOpen={isSubmenuOpen}
                            getLocationById={getLocationById}
                            _exchangeLabel={_exchangeLabel}
                            onShowTrackings={onShowTrackings}
                            onShowSlotHistories={onShowSlotHistories}
                            onShowGenerateNewPin={onShowGenerateNewPin}
                            onRemoveFacility={onRemoveFacility}
                            onGetQRCodeHandler={onGetQRCodeHandler}
                            onOpenDoor={onOpenDoor}
                            onRemoveSlot={onRemoveSlot}
                            showStatus={showStatus}
                            openSubmenuHandle={openSubmenuHandle}
                            onOpenSlot={onOpenSlot}
                            index={index}
                        />
                    </>
                );
            })}
            </div>
        </>
    )
}
export default FacilitiesList;